
hmi.constant.conection_types = {
    simple: 0,
    double: 1,
    eblow: 2
};

hmi.utils.load_svg_symbol('assets/images/hmiCommponents/conection-simple-tb.svg', hmi.symbols, 'TB');
hmi.utils.load_svg_symbol('assets/images/hmiCommponents/conection-simple-lr.svg', hmi.symbols, 'LR');
hmi.utils.load_svg_symbol('assets/images/hmiCommponents/conection-dtb.svg', hmi.symbols, 'DTB');
hmi.utils.load_svg_symbol('assets/images/hmiCommponents/connection-drl.svg', hmi.symbols, 'DLR');
hmi.utils.load_svg_symbol('assets/images/hmiCommponents/conection-elbow-bl.svg', hmi.symbols, 'ELBOW_BL');
hmi.utils.load_svg_symbol('assets/images/hmiCommponents/conection-elbow-br.svg', hmi.symbols, 'ELBOW_BR');
hmi.utils.load_svg_symbol('assets/images/hmiCommponents/conection-elbow-tl.svg', hmi.symbols, 'ELBOW_TL');
hmi.utils.load_svg_symbol('assets/images/hmiCommponents/conection-elbow-tr.svg', hmi.symbols, 'ELBOW_TR');

hmi.utils.connections = function () {

    var rectComponent,
        conect_type = hmi.constant.conection_types.simple,
        elbow_dir_connection = hmi.constant.pipeCPosition.B,
        position_connection = hmi.constant.pipeCPosition.B;


    var select_conection = function () {
        var svg = '';
        if (conect_type === hmi.constant.conection_types.simple) {
            switch (position_connection) {
                case hmi.constant.pipeCPosition.T:
                case hmi.constant.pipeCPosition.B:
                    svg = hmi.symbols.TB;
                    break;
                case hmi.constant.pipeCPosition.L:
                case hmi.constant.pipeCPosition.R:
                    svg = hmi.symbols.LR;
                    break;
            }
        }
        if (conect_type === hmi.constant.conection_types.double) {
            switch (position_connection) {
                case hmi.constant.pipeCPosition.T:
                case hmi.constant.pipeCPosition.B:
                    svg = hmi.symbols.DTB;
                    break;
                case hmi.constant.pipeCPosition.L:
                case hmi.constant.pipeCPosition.R:
                    svg = hmi.symbols.DLR;
                    break;
            }
        }
        if (conect_type === hmi.constant.conection_types.eblow) {
            switch (position_connection) {
                case hmi.constant.pipeCPosition.T:
                    if (elbow_dir_connection === hmi.constant.pipeCPosition.L)
                        svg = hmi.symbols.ELBOW_TL;
                    else if (elbow_dir_connection === hmi.constant.pipeCPosition.R)
                        svg = hmi.symbols.ELBOW_TR;
                    break;
                case hmi.constant.pipeCPosition.B:
                    if (elbow_dir_connection === hmi.constant.pipeCPosition.L)
                        svg = hmi.symbols.ELBOW_BR;
                    else if (elbow_dir_connection === hmi.constant.pipeCPosition.R)
                        svg = hmi.symbols.ELBOW_BL;
                    break;
                case hmi.constant.pipeCPosition.L:
                    if (elbow_dir_connection === hmi.constant.pipeCPosition.T)
                        svg = hmi.symbols.ELBOW_BL;
                    else if (elbow_dir_connection === hmi.constant.pipeCPosition.B)
                        svg = hmi.symbols.ELBOW_TL;
                    break;
                case hmi.constant.pipeCPosition.R:
                    if (elbow_dir_connection === hmi.constant.pipeCPosition.T)
                        svg = hmi.symbols.ELBOW_BR;
                    else if (elbow_dir_connection === hmi.constant.pipeCPosition.B)
                        svg = hmi.symbols.ELBOW_TR;
                    break;
            }
        }
        return svg;
    };

    var generate_position = function (d) {
        var positionAttrs = {
            transform: null,
            positionPipe: {},
        };
        var xW = (d.width - rectComponent.width) / 2;
        var xH = (d.height - rectComponent.height) / 2;
        var transformValue = {
            scaleWidth: 1,
            scaleHeight: 1,
        };
        switch (position_connection) {
            case hmi.constant.pipeCPosition.T:
                transformValue.x = (parseInt(d.width - rectComponent.width) / 2);
                transformValue.y = (0 - rectComponent.height);
                if (conect_type === hmi.constant.conection_types.double) {
                    positionAttrs.positionPipe[hmi.constant.pipeCPosition.L] = { x: d.x + xW, y: d.y - rectComponent.height };
                    positionAttrs.positionPipe[hmi.constant.pipeCPosition.R] = { x: d.x + d.width - xW, y: d.y - rectComponent.height };
                    transformValue.scaleHeight = (d.config && d.config.pipeSize) ? d.config.pipeSize : transformValue.scaleHeight;
                    transformValue.y = transformValue.y * transformValue.scaleHeight;
                }
                if (conect_type === hmi.constant.conection_types.simple) {
                    positionAttrs.positionPipe[hmi.constant.pipeCPosition.T] = { x: d.x + xW, y: d.y - rectComponent.height };
                    transformValue.scaleWidth = (d.config && d.config.pipeSize) ? d.config.pipeSize : transformValue.scaleWidth;
                    transformValue.x = transformValue.x / transformValue.scaleWidth;
                }

                break;
            case hmi.constant.pipeCPosition.B:
                transformValue.x = (parseInt(d.width - rectComponent.width) / 2);
                transformValue.y = (parseInt(d.height));

                if (conect_type === hmi.constant.conection_types.double) {
                    positionAttrs.positionPipe[hmi.constant.pipeCPosition.L] = { x: d.x + xW, y: d.y + d.height };
                    positionAttrs.positionPipe[hmi.constant.pipeCPosition.R] = { x: d.x + d.width - xW, y: d.y + d.height };
                    transformValue.scaleHeight = (d.config && d.config.pipeSize) ? d.config.pipeSize : transformValue.scaleHeight;
                }
                if (conect_type === hmi.constant.conection_types.simple) {
                    positionAttrs.positionPipe[hmi.constant.pipeCPosition.B] = { x: d.x + xW, y: d.y + d.height + rectComponent.height };
                }

                break;
            case hmi.constant.pipeCPosition.L:
                transformValue.x = (0 - rectComponent.width);
                transformValue.y = (parseInt(d.height - rectComponent.height) / 2);

                if (conect_type === hmi.constant.conection_types.double) {
                    positionAttrs.positionPipe[hmi.constant.pipeCPosition.T] = { x: d.x - rectComponent.width, y: d.y + xH };
                    positionAttrs.positionPipe[hmi.constant.pipeCPosition.B] = { x: d.x - rectComponent.width, y: d.y + d.height - xH };
                    transformValue.scaleWidth = (d.config && d.config.pipeSize) ? d.config.pipeSize : transformValue.scaleWidth;
                    transformValue.x = transformValue.x * transformValue.scaleWidth;

                }
                if (conect_type === hmi.constant.conection_types.simple) {
                    positionAttrs.positionPipe[hmi.constant.pipeCPosition.L] = { x: d.x + xW, y: d.y - rectComponent.height };
                }

                break;
            case hmi.constant.pipeCPosition.R:
                transformValue.x = (parseInt(d.width));
                transformValue.y = (parseInt(d.height - rectComponent.height) / 2);

                if (conect_type === hmi.constant.conection_types.double) {
                    positionAttrs.positionPipe[hmi.constant.pipeCPosition.T] = { x: d.x + d.width, y: d.y + xH };
                    positionAttrs.positionPipe[hmi.constant.pipeCPosition.B] = { x: d.x + d.width, y: d.y + d.height - xH };
                    transformValue.scaleWidth = (d.config && d.config.pipeSize) ? d.config.pipeSize : transformValue.scaleWidth;
                }
                if (conect_type === hmi.constant.conection_types.simple) {
                    positionAttrs.positionPipe[hmi.constant.pipeCPosition.R] = { x: d.x + xW, y: d.y - rectComponent.height };
                }

                break;
        }
        positionAttrs.transform = 'translate(' + transformValue.x + ',' + transformValue.y + ')' +
            'scale(' + transformValue.scaleWidth + ',' + transformValue.scaleHeight + ')';
        return positionAttrs;
    };

    function connections(gEnter, gComponent) {
        gComponent.insert('g', ':first-child')
            .classed('connection-component', true);

        gEnter.select('g.connection-component')
            .html(select_conection())
            .attr('transform', function (d) {
                rectComponent = d3.select(this).node().getBBox();
                var positionAttrs = generate_position(d);
                d.positionPipe = positionAttrs.positionPipe;
                return positionAttrs.transform;
            });
        gEnter.select('g.Connection_background')
            .attr('fill', function (d) {
                if (d.config && d.config.pipeColor)
                    return d.config.pipeColor;
                else
                    return 'none'
            })
            .style('opacity', function (d) {
                return (d.config && d.config.pipeColor && d.config.pipeColor != 'none') ? hmi.constant.opacity : 0;
            });
    }

    // connections.dispatch = dispatch;
    connections.options = hmi.utils.optionsFunc.bind(connections);

    connections._calls = new function () {

    }
    connections._options = Object.create({}, {
        conect_type: { get: function () { return conect_type }, set: function (_) { conect_type = _ } },
        elbow_dir_connection: { get: function () { return elbow_dir_connection }, set: function (_) { elbow_dir_connection = _ } },
        position_connection: { get: function () { return position_connection }, set: function (_) { position_connection = _ } },
    });
    hmi.utils.initOptions(connections);
    return connections;
};